export class UsuarioAuxModel  {
    idUsuario: number;
    isAdmin: boolean;
}



// WEBPACK FOOTER //
// ./src/app/util/model/usuario-aux.model.ts